'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Checkbox = require('./components/Checkbox.js');
var Radio = require('./components/Radio.js');
var OptionProvider = require('./components/OptionProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function SelectList(props) {
  const {
    value,
    options,
    limit = options.length,
    isRequired,
    isLoading
  } = props;
  const uniqueOptions = React.useMemo(() => new Set(options.map(o => o.value)).size === options.length, [options]);
  const isMultiple = limit > 1;
  if (!uniqueOptions) {
    throw new Error('Options must have unique value properties.');
  }
  if (isMultiple && value && !Array.isArray(value)) {
    throw new Error('Multi-select requires array provided to value prop.');
  }
  if (isLoading) return null;
  const InputComponent = isRequired && limit === 1 ? Radio.Radio : Checkbox.Checkbox;
  return /*#__PURE__*/React__default["default"].createElement(InputComponent, props);
}

exports.useOption = OptionProvider.useOption;
exports.SelectList = SelectList;
